module.exports = __webpack_public_path__ + "img/academy_popup_0.25c1cb75.svg";